import { z } from 'zod';
export const sendRunStatusSchema = z.enum(['queued', 'running', 'stopping', 'finished', 'stopped']);
export const SEND_RUN_STALE_MINUTES = 3;
export const SEND_REMAINING_MAX_AGE_DAYS = 7;
export const REMAINING_TOO_OLD_MESSAGE = `This send ended more than ${SEND_REMAINING_MAX_AGE_DAYS} days ago. Select the invoices again to send them.`;
export const ALREADY_RUNNING_MESSAGE = 'A send is already running for this association. Wait for it to finish, or stop it.';
export const sendLineOutcomeSchema = z.enum([
    'sent',
    'sent_resend',
    'skipped_no_email',
    'skipped_already_sent',
    'skipped_mail_only',
    'skipped_closed',
    'failed',
    'not_found',
    'no_qbo_invoice',
]);
const lineIds = {
    occurrenceDisplayId: z.string().min(1),
    propertyDisplayId: z.string().min(1),
    propertyId: z.number().int().positive(),
};
const sendableLine = {
    ...lineIds,
    qboInvoiceId: z.string().min(1),
    docNumber: z.string().optional(),
};
export const sendRunLineSchema = z.discriminatedUnion('outcome', [
    z.object({ outcome: z.literal('pending'), ...sendableLine }),
    z.object({ outcome: z.literal('sending'), ...sendableLine, claimedAt: z.string().datetime() }),
    z.object({
        outcome: z.literal('unknown'),
        ...sendableLine,
        claimedAt: z.string().datetime(),
        errorMessage: z.string(),
    }),
    z.object({
        outcome: sendLineOutcomeSchema,
        ...lineIds,
        errorMessage: z.string().optional(),
        docNumber: z.string().optional(),
    }),
]);
export const sendRunLinesSchema = z.array(sendRunLineSchema);
//# sourceMappingURL=arSendRun.js.map